import script from "./_card.vue?vue&type=script&setup=true&lang=js"
export * from "./_card.vue?vue&type=script&setup=true&lang=js"

import "./_card.vue?vue&type=style&index=0&id=81329c42&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-81329c42"]])

export default __exports__